  
export const excludedUsers: string[] = [
  'nA34YQrBRCOORLkUQLRs3xgTbls2', // samuel.arlig@protonmail.com
  'bcftfdlSlhM3fIDecV3MRTYpcEV2', // samuel.arlig@gmail.com
  'ExWPEJnGFNg2WKx9CDCRCI6CjlG2', // ulf.arlig@gmail.com
]
